import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatValue',
  standalone :false
})
export class FormatValuePipe implements PipeTransform {

  transform(value: any, field: string): any {
    return field.includes('EndDay') && value === null ? 100000 : value;
  }

}
